import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _Skeleton from "choerodon-ui/lib/skeleton";
var _excluded = ["packageName", "comp"];
import React, { useEffect, useMemo, useState } from 'react';
import EventEmitter from 'event-emitter';
import dynamic from 'dva/dynamic';
var LoadingCom = function LoadingCom() {
  return /*#__PURE__*/React.createElement(_Skeleton, {
    active: true,
    className: "loading"
  });
};
var MFComponentStore = new Map();
if (process.env.NODE_ENV === 'development') {
  window._hzero_MFComponentStore = MFComponentStore;
}
var MFComponentStoreListen = new EventEmitter();
var MfComponent = function MfComponent(props) {
  var packageName = props.packageName,
    comp = props.comp,
    compProps = _objectWithoutProperties(props, _excluded);
  var _useMemo = useMemo(function () {
      if (comp.includes('--')) {
        return comp.split('--');
      }
      if (packageName) {
        return [packageName, comp];
      }
      var hzeroMfCodeExposes = window.hzeroMfCodeExposes || {};
      if (hzeroMfCodeExposes[comp] && hzeroMfCodeExposes[comp].package) {
        return [hzeroMfCodeExposes[comp].package, hzeroMfCodeExposes[comp].code || comp];
      }
      return ['', comp];
    }, [comp, packageName]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    _packageName = _useMemo2[0],
    _comp = _useMemo2[1];
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    c = _useState2[0],
    setC = _useState2[1];
  useEffect(function () {
    var _namespace = _packageName;
    var mapKey = "".concat(_namespace, "---").concat(_comp);
    var _setC = function _setC() {
      var mapValue = MFComponentStore.get(mapKey); // eslint-disable-next-line no-shadow

      var c = mapValue === null || mapValue === void 0 ? void 0 : mapValue.comp;
      if (c.loader) {
        // c = dynamic({
        //   component: c.loader,
        // });
        c = dynamic({
          app: window.dvaApp,
          models: [],
          component: c.loader
        }); // c = dynamic({
        //   loader: c.loader,
        // });
      }

      setC(function () {
        return c;
      });
    };
    if (_namespace) {
      if (MFComponentStore.has(mapKey)) {
        _setC();
      } else {
        setC(function () {
          return function () {
            return /*#__PURE__*/React.createElement(LoadingCom, null);
          };
        });
      }
    } else {
      setC(function () {
        return function () {
          return /*#__PURE__*/React.createElement("div", null, "\u53C2\u6570\u9519\u8BEF");
        };
      });
    }
    var eventName = "set ".concat(mapKey);
    MFComponentStoreListen.on(eventName, _setC);
    return function () {
      MFComponentStoreListen.off(eventName, _setC);
    };
  }, [_packageName, _comp]);
  if (!c) {
    return /*#__PURE__*/React.createElement(LoadingCom, null);
  }
  return React.createElement(c, compProps, props.children);
};
/**
 * 设置跨模块组件
 * @param namespace 命名空间
 * @param compCode code
 * @param comp 组件
 * @param priority 优先级
 * @returns
 */

var setComponent = function setComponent(namespace, compCode, comp) {
  var priority = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var mapKey = "".concat(namespace, "---").concat(compCode);
  var oldValue;
  if (MFComponentStore.has(mapKey)) {
    oldValue = MFComponentStore.get(mapKey);
    if (oldValue.priority > priority) {
      return;
    }
  }
  var mapValue = {
    namespace: namespace,
    compCode: compCode,
    comp: comp,
    priority: priority
  };
  MFComponentStore.set(mapKey, mapValue);
  var eventName = "set ".concat(mapKey);
  MFComponentStoreListen.emit(eventName, mapValue, oldValue);
};
if (process.env.NODE_ENV === 'development') {
  window._hzero_setComponent = setComponent;
}
export { MfComponent, setComponent };